<template>
  <div v-if="showNotifyInfo" class="renewal-warning">
    <img :src="require('@/assets/img/renewal_notice.png')" alt="" />
    <span>{{ notifyInfo }}</span>
    <p class="btn" @click="jumpRenewPage">立即续费</p>
  </div>
</template>

<script>
import Constant, { CHAIN_TYPE } from '@/lib/constant';
import { hasPermission } from '@/util';

export default {
  name: 'renewalWarning',
  props: {
    isChain: {
      type: Number,
      default: 1
    },
    from: {
      type: Number
    }
  },
  data() {
    return {
      notifyInfo: '',
      showNotifyInfo: false
    };
  },
  created() {
    this.getRenewalNotifyInfo();
  },
  methods: {
    async getRenewalNotifyInfo() {
      let { notifyInfo, showNotifyInfo } = await Fetch.getRenewalNotifyInfo({ applySource: 1 });
      this.notifyInfo = notifyInfo;
      this.showNotifyInfo = showNotifyInfo;

      // 首页展示续费提醒时埋点
      if (this.showNotifyInfo && this.from === 1) {
        Telescope.trackPage({ trackId: 'zywzpc-page-homepage-renewal-reminder' });
      }
    },
    jumpRenewPage() {
      const { isChain } = this;
      const { MONOMER } = CHAIN_TYPE;
      // 首页点击续费跳转
      if (this.from === 1) {
        Telescope.trackEvent({ trackId: 'zywzpc-click-homepage-renewal-confirm' });
      }
      // 如果是单体只有门店账户，跳转门店账户
      if (isChain === MONOMER) return this.$router.push('/shopAccount');
      // 如果是连锁且只要有公司负责人就跳转续费
      if (hasPermission([Constant.RoleList.a])) return this.$router.push('/renewalStore');
      // 如果是连锁且只要有店长就跳转门店账户
      if (hasPermission([Constant.RoleList.d])) return this.$router.push('/shopAccount');
    }
  }
};
</script>

<style lang="scss" scoped>
.renewal-warning {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  margin-bottom: 16px;
  background: #fff7e6;
  font-size: 14px;
  line-height: 14px;
  color: #ff8200;
  img {
    height: 20px;
    width: 20px;
    margin-right: 8px;
  }
  .btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    margin-left: 8px;
    text-align: center;
    background: #ff8200;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #ffffff;
  }
}
</style>
